<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />

          <b-button
            v-if="getUserPermission('CREATE_USER_ROLE')"
            variant="primary"
            @click="
              showModal('modal-lg'),
              (isReadonly = false),
              (modalType = { type: 'add', text: 'Create New Role' })
            "
          >
            Add
          </b-button>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              variant="primary"
              class="mr-1"
              @click="showModal('modal-filter')"
            >
              <feather-icon icon="FilterIcon" /> Filter
            </b-button>
            <Button
              label="Reset Filter"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>
    </div>

    <b-table
      :items="roleList"
      responsive
      :busy="isBusy"
      :fields="tableHeaders"
      primary-key="id"
      show-empty
      empty-text="No data available"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>
      <!-- Column: Role Name -->
      <template #cell(roleName)="data">
        {{ data.value }}
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="getUserPermission('MODIFY_USER_ROLE')"
              @click="updateViewRole(data.item, 'edit')"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Modify</span>
            </b-dropdown-item>
            <b-dropdown-item @click="updateViewRole(data.item, 'view')">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />
    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      :ok-title="modalType.buttonLabel"
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="modalType.text"
      :ok-disabled="isLoading"
      @ok="handleSubmit"
      @hidden="clearForm"
    >
      <b-form @submit.prevent="handleSubmit">
        <validation-observer ref="roleRules">
          <b-row class="match-height">
            <!-- Role Name -->
            <b-col md="12">
              <InputField
                id="role-name"
                v-model="roleFormData.name"
                label="Role Name"
                placeholder="Enter role name"
                type="text"
                error-name="Role Name"
                rules="required"
                for="role-name"
                :readonly="isReadonly"
                onpaste="return false;"
                :is-allow-special-characters="false"
              />
            </b-col>
            <!-- Role Name -->
            <!-- Role Description -->
            <b-col md="12">
              <TextAreaField
                id="role-description"
                v-model="roleFormData.description"
                rows="4"
                label="Role Description"
                placeholder="Enter role description"
                type="text"
                error-name="Role Description"
                rules="required"
                for="role-description"
                :readonly="isReadonly"
              />
            </b-col>
            <!-- Role Description -->
          </b-row>
          <div class="business-card">
            <app-collapse
              class="business-items"
              type="margin"
              accordion
            >
              <app-collapse-item
                v-for="(item, key) in sortPermissions"
                :key="key"
                :title="key"
                class="card-item px-2"
              >
                <b-row class="ml-0">
                  <b-col
                    md="3"
                    class="business-item mr-1 mb-1"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <b-form-checkbox
                        v-model="allSelected[key]"
                        :aria-describedby="key"
                        :aria-controls="key"
                        :disabled="isReadonly"
                        @change="toggleAll(item.slice(1), $event)"
                      >
                        Select All
                      </b-form-checkbox>
                    </div>
                  </b-col>
                  <b-col
                    v-for="(permission, j) in item.slice(1)"
                    :key="j"
                    md="3"
                    class="business-item mr-1 mb-1"
                  >
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <b-form-checkbox
                        v-model="roleFormData.permissions"
                        :value="permission.name"
                        :disabled="isReadonly"
                      >
                        {{ permission.description }}
                      </b-form-checkbox>
                    </div>
                  </b-col>
                </b-row>
              </app-collapse-item>
            </app-collapse>
          </div>
        </validation-observer>
      </b-form>
      <template
        v-if="isReadonly"
        #modal-footer="{ }"
      >
        <div />
      </template></b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="modal-filter"
      ok-title="Apply"
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      title="Filters"
      modal-footer
      @ok="getRoles"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- Name  -->
        <b-col md="6">
          <InputField
            id="name"
            v-model="filter.name"
            label="Name"
            placeholder="Enter name"
            type="text"
            for="name"
            onpaste="return false;"
            :is-allow-special-characters="false"
          />
        </b-col>
        <!-- Name -->
      </b-row>
    </b-modal>
    <!-- Filter modal -->
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BDropdown,
  BDropdownItem,
  BModal,
  BForm,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { permissionMixin } from '@core/mixins/permission'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import InputField from '../../forms/InputField.vue'
import Button from '../../components/button/Button.vue'
import TextAreaField from '../../forms/TextAreaField.vue'
import { adminPermissions } from '../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    Button,
    BTable,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BModal,
    BForm,
    TableEntries,
    ValidationObserver,
    InputField,
    BFormCheckbox,
    TextAreaField,
    TablePagination,
    AppCollapse,
    AppCollapseItem,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      required,
      sortBy: 'id',
      isBusy: false,
      sortDesc: false,
      showSpinner: false,
      tableHeaders: [
        { key: 'SN', sortable: true, label: 'S/N' },
        { key: 'name', sortable: true },
        { key: 'description', sortable: true },
        { key: 'actions' },
      ],
      roleFormData: {
        name: '',
        description: '',
        permissions: [],
      },
      roleList: [],
      permissions: {},
      allSelected: {},
      loading: false,
      modalType: {
        type: '',
        text: '',
        buttonLabel: 'Save',
      },
      filter: {
        name: '',
      },
      isReadonly: false,
    }
  },
  computed: {
    ...mapGetters(['generalLedger/generalLedgerList']),
    sortPermissions() {
      return Object.fromEntries(Object.entries(this.permissions).sort())
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.getRoles()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.getRoles()
    },
  },
  mounted() {
    this.getRoles()
    this.fetchAllPermission()
  },
  methods: {
    ...mapActions({
      getAllPermission: 'admin/getAllPermission',
      addRole: 'admin/addRole',
      editRole: 'admin/editRole',
      getAllRoles: 'admin/getRoles',
    }),
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn')
    },
    toggleAll(arr, checked) {
      arr.forEach(element => {
        if (checked) {
          this.roleFormData.permissions.push(element.name)
        } else {
          this.roleFormData.permissions = this.roleFormData.permissions.filter(
            item => element.name !== item,
          )
        }
      })
    },
    async fetchAllPermission() {
      this.isBusy = true
      try {
        const response = await this.getAllPermission({ permission: adminPermissions.VIEW_USER_ROLE })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.permissions = data.data.reduce((memo, curr) => {
            // eslint-disable-next-line no-param-reassign
            memo[curr.groupName] = Array.isArray(memo[curr.groupName])
              ? memo[curr.groupName].concat(curr)
              : [memo[curr.groupName]].concat(curr)
            return memo
          }, {})
          this.isBusy = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    updateViewRole(data, actionType) {
      if (actionType === 'view') {
        this.isReadonly = true
        this.modalType = { type: 'view', text: 'View Role', id: data.id }
      } else {
        this.isReadonly = false
        this.modalType = {
          type: 'update', text: 'Modify Role', id: data.id, buttonLabel: 'Update',
        }
      }
      this.toggleModal()
      const { name, description, permissions } = data
      this.roleFormData = { name, description, permissions }
    },
    async getRoles() {
      this.isBusy = true
      try {
        const response = await this.getAllRoles({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
          permission: adminPermissions.VIEW_USER_ROLE,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.roleList = data.data
          this.totalCount = data.totalItems
          this.isBusy = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.roleRules.validate().then(success => {
        if (success) {
          this.confirm(this.createUpdateRole, { text: `Are you sure you want to ${this.modalType.type} this Role?` })
        }
      })
    },
    async createUpdateRole() {
      this.isLoading = true
      try {
        const response = this.modalType.type === 'add'
          ? await this.addRole(this.roleFormData)
          : await this.editRole({
            ...this.roleFormData,
            id: this.modalType.id,
          })
        if (response.status === 200) {
          this.alertSuccess({ text: `Your request to ${this.modalType.type} ${this.roleFormData.name} Role was successful` })
          this.getRoles()
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.alertError({ text: `Your request to ${this.modalType.type} Role failed. Reason: ${responseError.errorMessage}` })
        })
      } finally {
        this.isLoading = false
        this.toggleModal()
        this.clearForm()
      }
    },

    clearForm() {
      this.roleFormData = {
        name: '',
        description: '',
        permissions: [],
      }
      this.allSelected = {}
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.getRoles()
    },
  },
}
</script>

<style lang="scss" scoped>
.select-all {
  height: 50.3px;
}
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
